/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21haW4vcG1zL3Byb2plY3QtZGV0YWlscy9jcm0tZW1haWwtbG9nL2NybS1lbWFpbC1sb2ctcHJldmlldy9jcm0tZW1haWwtbG9nLXByZXZpZXcuY29tcG9uZW50LnNjc3MifQ== */"];
export { styles as styles };
